"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = __importDefault(require("@graphql-mesh/openapi"));
const BASE_URL = 'http://ip-api.com';
class IPAPIHandler extends openapi_1.default {
    constructor({ name, config, cache, pubsub }) {
        config.source = require.resolve('@graphql-portal/ip-api/src/source.json');
        config.baseUrl = BASE_URL;
        super({ name, config, cache, pubsub });
    }
}
exports.default = IPAPIHandler;
//# sourceMappingURL=handler.js.map